import { gql } from "@apollo/client";

export const updateTenantInformation = gql`
  mutation UpdateTenant($user: UpdateUserInputType!) {
    updateUserInfo(user: $user) {
      value
    }
  }
`;
